<template>
  <div class="main">
    <Loading v-if="loading" />
    <ModalIdle v-if="ModalIdleData" />
    <ServerMessage v-if="snackbar" />
    <div class="sideBar">
      <SideBar />
    </div>
    <div class="panel">
      <transition name="view">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import SideBar from "../components/SideBar";
import ModalIdle from "../components/ModalIdle";
export default {
  components: { SideBar, ModalIdle },
  metaInfo: {
    title: "Teller/Dashboard",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },

  data: () => ({
    ModalIdleData: false,
  }),

  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    loading() {
      return this.$store.state.User.loading;
    },
    snackbar() {
      return this.$store.state.User.snackbar;
    },
  },

  watch: {
    isIdle: function(val) {
      if (val) {
        this.ModalIdleData = true;
        this.$store.commit("setUser", null);
      }
    },
  },
};
</script>
<style scoped>
.view-enter-active,
.view-leave-active {
  transition: opacity 0.5s ease-in-out, transform 0.5s ease;
}
.view-enter-active {
  transition-delay: 0.5s;
}
.view-enter {
  opacity: 0;
  transform: translateY(-100px);
}
.view-enter-to {
  opacity: 1;
  transform: translateY(0px);
}
.view-leave {
  opacity: 1;
  transform: translateY(0px);
}
.view-leave-to {
  opacity: 0;
  transform: translateY(100px);
}

.main {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: minmax(100vh, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas: "sideBar panel panel panel panel";
  width: 100%;
}
.sideBar {
  grid-area: sideBar;
  background-image: linear-gradient(to bottom, #9f09d7, #bd2427);
}
.panel {
  grid-area: panel;
  background-image: linear-gradient(to bottom, #9f09d7, #bd2427);
}
.logo {
  margin-left: 20px;
  margin-top: 20px;
  padding: 5px;
  width: 180px;
  border-top-left-radius: 15px;
  border-bottom-right-radius: 15px;
  background-color: white;
}
.balance {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 70px;
  padding-left: 20px;
  margin-top: 30px;
  margin-bottom: 50px;
  background-color: white;
}
.balance h4 {
  color: #ad1684;
}
.card {
  background-color: transparent !important;
  margin-right: 30px !important;
}
.list {
  background-color: transparent !important;
  margin-left: 20px;
}
.leftIcon {
  margin-right: 25px;
}
.pointer :hover {
  cursor: pointer;
  border-radius: 5px;
}
.highlighted {
  background-color: #fff;
  color: white;
  border-radius: 5px;
}
.unactive {
  color: white !important;
}
.active {
  color: #ad1684 !important;
  margin-left: 20px;
}
.vertical {
  display: flex;
  flex: 1;
  height: 1px;
  background-color: white;
  margin-left: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.Logout {
  height: 150px;
  display: flex;
  align-items: flex-end;
}

@media only screen and (max-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(90px, auto);
    margin: 0 auto;
    padding: 0px;
    grid-template-areas:
      "panel panel panel panel panel"
      "panel panel panel panel panel"
      "panel panel panel panel panel"
      "panel panel panel panel panel"
      "panel panel panel panel panel"
      "panel panel panel panel panel"
      "panel panel panel panel panel"
      "panel panel panel panel panel"
      "panel panel panel panel panel";
  }
  .sideBar {
    display: none;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
